import axiosInstance from "./axios-instance"

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const addNewStatus = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`statuses/add`, payload)

    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

const getAllStatuses = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`statuses/getAll`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    })

    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

const addNewProjectStatus = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projectStatuses/add`, payload)

    return response.data
  } catch (error) {
    console.error(error)
  }
}

const getProjectStatuses = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`projectStatuses/get`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    })

    return response.data
  } catch (error) {
    console.error(error)
  }
}

export { addNewStatus, getAllStatuses, addNewProjectStatus, getProjectStatuses }
